const methodsModule = require(`./methods.api`);

export default methodsModule;
